var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2175 18H36.0001C36.0001 16.3754 35.7835 14.8015 35.38 13.3043H17.2175V18Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2175 8.60877H33.3582C32.2563 6.81073 30.8475 5.22146 29.2048 3.91309H17.2175V8.60877Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 35.9999C22.2364 35.9999 26.1301 34.5358 29.2048 32.0869H6.79541C9.87018 34.5358 13.7639 35.9999 18.0001 35.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64195 27.3912H33.3581C34.2427 25.9478 34.9287 24.37 35.3799 22.6956H0.620117C1.07131 24.37 1.75735 25.9478 2.64195 27.3912Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33794 2.81095H9.97826L8.45248 3.91943L9.0353 5.71303L7.50959 4.60455L5.98387 5.71303L6.48731 4.16355C5.14392 5.28258 3.96647 6.59363 2.99616 8.05444H3.52174L2.55052 8.76002C2.3992 9.01245 2.25408 9.26887 2.115 9.5291L2.57878 10.9565L1.71352 10.3279C1.49843 10.7835 1.3017 11.2495 1.12486 11.7252L1.63582 13.2979H3.52174L1.99596 14.4064L2.57878 16.2L1.05307 15.0915L0.139148 15.7556C0.0476719 16.4909 0 17.2399 0 18H18C18 8.05894 18 6.88697 18 0C14.4442 0 11.1294 1.03148 8.33794 2.81095ZM9.0353 16.2L7.50959 15.0915L5.98387 16.2L6.5667 14.4064L5.04091 13.2979H6.92684L7.50959 11.5043L8.09234 13.2979H9.97826L8.45248 14.4064L9.0353 16.2ZM8.45248 9.16291L9.0353 10.9565L7.50959 9.84804L5.98387 10.9565L6.5667 9.16291L5.04091 8.05444H6.92684L7.50959 6.26084L8.09234 8.05444H9.97826L8.45248 9.16291ZM15.4918 16.2L13.9661 15.0915L12.4404 16.2L13.0232 14.4064L11.4974 13.2979H13.3834L13.9661 11.5043L14.5489 13.2979H16.4348L14.909 14.4064L15.4918 16.2ZM14.909 9.16291L15.4918 10.9565L13.9661 9.84804L12.4404 10.9565L13.0232 9.16291L11.4974 8.05444H13.3834L13.9661 6.26084L14.5489 8.05444H16.4348L14.909 9.16291ZM14.909 3.91943L15.4918 5.71303L13.9661 4.60455L12.4404 5.71303L13.0232 3.91943L11.4974 2.81095H13.3834L13.9661 1.01735L14.5489 2.81095H16.4348L14.909 3.91943Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/usa.158c90512645078c51d8394f165d499c.svg";
export { ForwardRef as ReactComponent };